import { motion } from "framer-motion";
import { HashLink } from "react-router-hash-link";
import { ArrowRight } from "lucide-react";
import { CASES, PRICING } from "@/lib/constants";

export default function OwnerCta() {
  const image = CASES[0].gallery[1];
  return (
    <section
      id="har-du-en-bolig"
      data-testid="owner-cta-section"
      className="relative bg-[#F1EFEA] overflow-hidden"
    >
      <div className="max-w-7xl mx-auto px-6 sm:px-8 lg:px-12 py-16 sm:py-24 lg:py-28">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-10 lg:gap-16 items-center">
          <motion.div
            initial={{ opacity: 0, y: 24 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true, margin: "-100px" }}
            transition={{ duration: 0.9, ease: "easeOut" }}
            className="lg:col-span-7"
          >
            <p className="overline mb-5 text-[10px] sm:text-xs">
              <span className="inline-block w-8 sm:w-10 h-px bg-[#D4AF37] align-middle mr-3 sm:mr-4" />
              For boligejere
            </p>
            <h2
              className="font-serif text-[2.5rem] sm:text-6xl lg:text-[5rem] text-[#111111] font-light tracking-tight leading-[1.02]"
              style={{ fontFamily: "Fraunces, serif" }}
            >
              Har du en <span className="italic text-[#C9A227]">bolig?</span>
            </h2>
            <p className="mt-6 max-w-xl text-[#444444] text-base sm:text-xl font-light leading-relaxed">
              Lad Gudiksen Stays stå for udlejning og den løbende drift.
            </p>

            <div className="mt-8 grid grid-cols-3 gap-4 sm:gap-8 max-w-lg border-t border-black/10 pt-6">
              {[PRICING.startup, PRICING.fee, PRICING.hidden].map((p) => (
                <div key={p.label}>
                  <div
                    className="font-serif text-xl sm:text-3xl text-[#111111] font-light"
                    style={{ fontFamily: "Fraunces, serif" }}
                  >
                    {p.value}
                  </div>
                  <div className="mt-1 text-[9px] sm:text-[11px] uppercase tracking-[0.18em] text-[#666666] leading-snug">
                    {p.label}
                  </div>
                </div>
              ))}
            </div>

            <div className="mt-10">
              <HashLink
                smooth
                to="/#contact"
                data-testid="owner-cta-btn"
                className="btn-gold group"
              >
                <span className="inline-flex items-center gap-2.5">
                  Bliv en del af Gudiksen Stays
                  <ArrowRight
                    size={14}
                    strokeWidth={1.5}
                    className="transition-transform duration-500 group-hover:translate-x-1"
                  />
                </span>
              </HashLink>
            </div>
          </motion.div>

          <motion.div
            initial={{ opacity: 0, scale: 0.96 }}
            whileInView={{ opacity: 1, scale: 1 }}
            viewport={{ once: true, margin: "-100px" }}
            transition={{ duration: 1.1, ease: [0.22, 1, 0.36, 1] }}
            className="lg:col-span-5 relative"
          >
            <div className="absolute -inset-3 border border-[#D4AF37]/40 pointer-events-none translate-x-3 translate-y-3" />
            <div className="relative aspect-[4/5] overflow-hidden bg-white">
              <img
                src={image}
                alt="Jyllandsgade Apartment - Aalborg"
                loading="lazy"
                decoding="async"
                className="w-full h-full object-cover"
              />
            </div>
          </motion.div>
        </div>
      </div>
    </section>
  );
}
